import React, { useState, useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api/client';
import { NotificationBadge } from './ui';
import '../App.css';

const UserLayout: React.FC = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [outstandingCount, setOutstandingCount] = useState(0);
  const [membershipChoiceCount, setMembershipChoiceCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    api.my.outstanding()
      .then(({ data }) => {
        if (!cancelled) setOutstandingCount(data.outstanding?.length ?? 0);
      })
      .catch(() => { /* silent */ });
    api.my.membershipsPendingCount()
      .then(({ data }) => {
        if (!cancelled) setMembershipChoiceCount(data.needsChoice ?? 0);
      })
      .catch(() => { /* silent */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="admin-layout">
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button
          className="sidebar-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          aria-label="Toggle Sidebar"
        >
          {sidebarOpen ? '❮' : '❯'}
        </button>
        <nav className="admin-nav">
          <ul>
            <li><Link to="/dashboard/calendar" onClick={() => setSidebarOpen(false)}>{t('sidebar.myCalendar')}</Link></li>
            <li><Link to="/dashboard/invitations" onClick={() => setSidebarOpen(false)}>{t('sidebar.eventInvitations')}</Link></li>
            <li><Link to="/dashboard/announcements" onClick={() => setSidebarOpen(false)}>{t('sidebar.announcements')}</Link></li>
            <li><Link to="/dashboard/communication" onClick={() => setSidebarOpen(false)}>{t('sidebar.communication')}</Link></li>
            <li><Link to="/dashboard/members" onClick={() => setSidebarOpen(false)}>{t('sidebar.myMembers')}</Link></li>
            <li>
              <Link to="/dashboard/memberships" onClick={() => setSidebarOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {t('sidebar.memberships')}
                <NotificationBadge count={membershipChoiceCount} aria-label={t('sidebar.memberships')} />
              </Link>
            </li>
            <li><Link to="/dashboard/activities" onClick={() => setSidebarOpen(false)}>{t('activities.title')}</Link></li>
            <li>
              <Link to="/dashboard/payments" onClick={() => setSidebarOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {t('sidebar.myPayments')}
                <NotificationBadge count={outstandingCount} aria-label={t('sidebar.myPayments')} />
              </Link>
            </li>
            <li><Link to="/dashboard/preferences" onClick={() => setSidebarOpen(false)}>{t('sidebar.preferences')}</Link></li>
            <li><Link to="/dashboard/open-events" onClick={() => setSidebarOpen(false)}>{t('sidebar.publicEvents')}</Link></li>
          </ul>
        </nav>
      </aside>
      <main className="admin-main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default UserLayout;
